const baseSize = 16;
// 设置 rem 函数
function setRem() {
  // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。

  var scale = "";
  // if (document.documentElement.clientWidth > 1920) {
  //   scale = document.documentElement.clientWidth / 2250;
  // } else {
  // if (document.documentElement.clientWidth <= 1920) {
  //   scale = 1;
  // } else {
  //   scale = document.documentElement.clientWidth / 2220;
  // }
  const currentPath = window.location; // 获取当前页面路径（如 /pages/home、/pages/detail 等）

  // ------------- 单独页面的自定义规则 -------------
  // 示例：路径包含 "/special-page" 的页面（可替换为你的目标页面路径）
  const isSpecialPage = currentPath.toString().indexOf("/daping2");

  const physicalWidth = screen.width * window.devicePixelRatio;
  // 获取屏幕物理高度（像素）
  const physicalHeight = screen.height * window.devicePixelRatio;
  if (isSpecialPage != -1) {
    if (document.documentElement.clientWidth < 1920) {
      if (document.documentElement.clientWidth <= 1280) {
        scale = 0.5;
      } else {
        if (
          (physicalWidth === 1600 && physicalHeight === 900) ||
          (physicalWidth === 1440 && physicalHeight === 900) ||
          (physicalWidth === 1366 && physicalHeight === 768) ||
          (physicalWidth === 1360 && physicalHeight === 768)
        ) {
          scale = 0.6;
        } else {
          scale = 0.8;
        }
      }
    } else if (document.documentElement.clientWidth === 1920) {
      scale = 0.8;
    } else {
      scale = 1;
    }
  } else {
    if (document.documentElement.clientWidth < 1920) {
      if (document.documentElement.clientWidth <= 1280) {
        scale = 0.5;
      } else {
        if (
          (physicalWidth === 1600 && physicalHeight === 900) ||
          (physicalWidth === 1440 && physicalHeight === 900) ||
          (physicalWidth === 1366 && physicalHeight === 768) ||
          (physicalWidth === 1360 && physicalHeight === 768)
        ) {
          scale = 0.6;
        } else {
          scale = 0.8;
        }
      }
    } else if (document.documentElement.clientWidth === 1920) {
      scale = 0.8;
    } else {
      scale = 1;
    }
  }
  // }
  //console.log(document.documentElement.clientWidth + "缩放比例" + scale);
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};
